import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, loadToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

const MEMBER_KEY = "fcw_active_member";

export function AuthProvider({ children }) {
  const [family, setFamily] = useState(null); // null=checking, false=no auth, obj=auth
  const [members, setMembers] = useState([]);
  const [activeMemberId, setActiveMemberId] = useState(
    localStorage.getItem(MEMBER_KEY) || null
  );

  const refreshMembers = useCallback(async () => {
    try {
      const { data } = await api.get("/members");
      setMembers(data);
      return data;
    } catch {
      return [];
    }
  }, []);

  useEffect(() => {
    const t = loadToken();
    if (!t) {
      setFamily(false);
      return;
    }
    api
      .get("/auth/me")
      .then(async ({ data }) => {
        setFamily(data.family);
        await refreshMembers();
      })
      .catch(() => {
        setToken(null);
        setFamily(false);
      });
  }, [refreshMembers]);

  const login = async (token, fam) => {
    setToken(token);
    setFamily(fam);
    const ms = await refreshMembers();
    if (ms.length && !activeMemberId) selectMember(ms[0].id);
  };

  const logout = () => {
    setToken(null);
    setFamily(false);
    setMembers([]);
    setActiveMemberId(null);
    localStorage.removeItem(MEMBER_KEY);
  };

  const selectMember = (id) => {
    setActiveMemberId(id);
    localStorage.setItem(MEMBER_KEY, id);
  };

  const activeMember = members.find((m) => m.id === activeMemberId) || null;
  const isParent = activeMember && (activeMember.role === "mom" || activeMember.role === "dad");

  return (
    <AuthCtx.Provider
      value={{
        family,
        members,
        activeMember,
        activeMemberId,
        isParent,
        login,
        logout,
        selectMember,
        refreshMembers,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}
